export const createMeterUtils = (setLoadstatus, setError, setProgress, setVisible, getsensorstatus, addwkhboeking, changeampere, schakelkwhnmeter, reloadplaatsen, setMeterStatus = null, setAmpereStatus = null, setMeterLoading = null, setAmpereLoading = null) => {
  const getstatus = (meterId) => {
    setLoadstatus("We halen de status op van de meter");
    if (setMeterLoading) setMeterLoading(true);

    getsensorstatus(meterId, { payload: "AQMAgAABheI=", field: "status" })
      .then((data) => {

        if (data.type === "SENSOR_ERROR") {
          setError("Er is een fout opgetreden bij het ophalen van de status");
          if (setMeterLoading) setMeterLoading(false);
          return;
        }
        // Sla de meter status resultaat op
        if (setMeterStatus) {
          const statusInfo = {
            success: data?.results?.electra?.ingeschakeld ? "De meter is ingeschakeld" : "De meter is uitgeschakeld",
            timestamp: new Date(),
            data: data.results || data.payload || data,
          };
          setMeterStatus(statusInfo);
        }

        reloadplaatsen();
        setLoadstatus(false);
        setError(false);
        setProgress(0);
        if (setMeterLoading) setMeterLoading(false);
      })
      .catch((error) => {
        console.error("Fout bij het ophalen van de status:", error);

        // Sla de error status op
        if (setMeterStatus) {
          setMeterStatus({
            success: false,
            timestamp: new Date(),
            error: "Fout bij ophalen status",
          });
        }

        setError("Er is een fout opgetreden bij het ophalen van de status");
        setLoadstatus(false);
        setProgress(0);
        if (setMeterLoading) setMeterLoading(false);
      });
  };

  const getstatusampere = (meterId) => {
    setLoadstatus("We halen de ampere status op van de meter");
    if (setAmpereLoading) setAmpereLoading(true);

    getsensorstatus(meterId, { payload: "AQMAhgABZeM=", field: "amperestatus" })
      .then((data) => {
        if (data.type === "SENSOR_ERROR") {
          setError("Er is een fout opgetreden bij het ophalen van de amperestatus");
          if (setAmpereLoading) setAmpereLoading(false);
          return;
        }

        // Sla de ampere status resultaat op
        if (setAmpereStatus) {
          const ampereInfo = {
            success: true,
            timestamp: new Date(),
            ampere: data?.results?.electra?.ampere || data.results.electra.ampere || "Onbekend",
            data: data.results || data.payload || data,
          };
          setAmpereStatus(ampereInfo);
        }

        reloadplaatsen();
        setLoadstatus(false);
        setError(false);
        setProgress(0);
        if (setAmpereLoading) setAmpereLoading(false);
      })
      .catch((error) => {
        console.error("Fout bij het ophalen van de amperestatus:", error);

        // Sla de error status op
        if (setAmpereStatus) {
          setAmpereStatus({
            success: false,
            timestamp: new Date(),
            error: "Fout bij ophalen ampere status",
          });
        }

        setError("Er is een fout opgetreden bij het ophalen van de amperestatus");
        setLoadstatus(false);
        setProgress(0);
        if (setAmpereLoading) setAmpereLoading(false);
      });
  };

  const submitaddkwh = (sensor, setAddnewkwh) => (vals) => {
    setLoadstatus("De nieuwe waarde wordt toegevoegd aan de boeking");
    let val = {
      ...vals,
      sensor_id: sensor.sensor._id,
    };
    addwkhboeking(sensor.sensor.boeking._id, val).then((data) => {
      if (data.type === "ADD_GASTEN_VERBRUIK") {
        setError(false);
        reloadplaatsen();
        setProgress(0);
        setAddnewkwh(false);
        setVisible(false);
      } else {
        setError("Er is een fout opgetreden bij het toevoegen van de kWh");
      }
    });
  };

  const submitchangeampere = (sensor, setAmpereState) => (vals) => {
    setLoadstatus("De nieuwe waarde wordt toegevoegd aan de boeking");
    let val = {
      ...vals,
      sensor_id: sensor.sensor._id,
    };
    changeampere(sensor.sensor.boeking._id, val).then((data) => {
      if (data.type === "ADD_GASTEN_VERBRUIK") {
        setError(false);
        reloadplaatsen();
        setProgress(0);
        setAmpereState(false);
        setVisible(false);
      } else {
        setError("Er is een fout opgetreden bij het toevoegen van de kWh");
      }
    });
  };

  const schakelenmeteractie = (sensor) => (status) => {
    setLoadstatus("We schakelen de meter in/uit");
    schakelkwhnmeter(sensor.device, { schakelen: status })
      .then((data) => {
        if (data.type === "SENSOR_ERROR") {
          setError("Er is een fout opgetreden bij het schakelen van de meter");
          return;
        }
        setLoadstatus(false);
        reloadplaatsen();
        setError(false);
        setVisible(false);
        setProgress(0);
      })
      .catch((error) => {
        setError("Er is een fout opgetreden bij het schakelen van de meter");
        setLoadstatus(false);
        setProgress(0);
      });
  };

  return {
    getstatus,
    getstatusampere,
    submitaddkwh,
    submitchangeampere,
    schakelenmeteractie,
  };
};
